import { useQuery } from 'react-query';
import { vendorKeys } from '@config/queryKeys';

import type { VendorBusinessInfo } from '../types/vendors';

import { useVendorApi } from './api';

type Options = {
  vendorId?: string;
};
export default function useVendorBusinessInfo({ vendorId = '' }: Options = {}) {
  const api = useVendorApi();
  const { data, isFetched, isFetching, isLoading, refetch } =
    useQuery<VendorBusinessInfo>(
      vendorKeys.businessInfo(vendorId),
      () => api.getBusinessInfo(vendorId),
      {
        enabled: !!vendorId,
      }
    );

  return {
    isFetched,
    isFetching,
    isLoading,
    refetch,
    businessInfo: data ?? ({} as VendorBusinessInfo),
  };
}
